import fetcher from '@api/fetchers/simpleFetcher';
import { getHost, HOST_TYPE } from '@utils/api-helper/host';
import { getClientAccessToken } from '@utils/auth/getClientAccessToken';

export default async function createProctorSession(isLive, quizUID) {
  const host = getHost(HOST_TYPE.TEST_SERIES);
  const accessToken = getClientAccessToken();
  const result = await fetcher(
    `${host}v1/quizzes/quiz/${quizUID}/proctoring/start/?islive=${isLive}`,
    { useCamelCase: false, authorization: accessToken }
  );

  const sessionId = result?.proctoring_details?.sessionId;
  if (!sessionId) {
    throw new Error(result?.message || 'Failed to create proctoring session');
  }

  return {
    sessionId,
    sessionToken: result?.proctoring_details?.sessionToken,
    accessTokenTTL: result?.proctoring_details?.accessTokenTTL,
    apiUrl: result?.proctoring_details?.apiUrl,
    rawResponse: result
  };
}
